import React from "react";
import { appDomain } from "../../domain/AppDomain";
import { AppRoutes } from "../../domain/navigation/AppRoutes";
import { EventNames } from "../../domain/events/Events";
import { IAttentionDay } from "../../domain/attentiondays/IAttentionDay";
import { BaseComponent } from "../core/BaseComponent";
import { AttentionDayRow } from "./AttentionDayRow";
import { AttentionDaysTableHeader } from "./AttentionDaysTableHeader";
export class AttentionDaysTable extends BaseComponent<{}, any> {
    componentDidMount() {
        this.getAttentionDays();
        this.subscribe(EventNames.reloadAttentiondays, this.getAttentionDays.bind(this));
    }
    async getAttentionDays() {
        const attentionDays = await appDomain.IAttentionDayService.requestAttentionDays();
        this.setStateWhenMounted({ attentionDays });
    }
    async removeAttentionDay(attentionDay: IAttentionDay) {
        if (window.confirm("Wilt u de attentiedag verwijderen?")) {
            await appDomain.IAttentionDayService.requestDeleteAttentionDay(attentionDay);
            await this.getAttentionDays();
        }
    }
    render() {
        if (this.state && this.state.attentionDays) {
            const attentionDays = this.state.attentionDays as IAttentionDay[];
            const tableRows: JSX.Element[] = [];

            attentionDays.forEach(d => tableRows.push(<AttentionDayRow key={(d.id || "").toString()} attentionDay={d} onRemove={() => this.removeAttentionDay(d)} onEdit={() => this.navigateTo(`${AppRoutes.attentiondays}/${d.id}`)} />));
            return (<table className="dagoverzicht">
                <AttentionDaysTableHeader />
                <tbody>
                    {tableRows}
                </tbody>
            </table>);
        }
        return null;
    }
}
